export default __webpack_public_path__ + "static/media/iAssets-white.cd4d7e20.png";